import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { View } from 'react-native';
import { component } from '@serviceos-rn/core';
import { TipConfig } from '../../../TipConfig';
import { OptionView } from '../Option/OptionView';
import { TipConfiguration } from '../../../Domain/DTOs/TipConfigurationDTO';
export const OptionsView = component({
    provider: TipConfig.provider,
    moduleName: TipConfig.moduleName,
    componentName: TipConfiguration.ComponentNames.options,
    style(theme, mediaQuery, window, props) {
        return {
            container: {},
            options: Object.assign({ flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }, props.mode === 'compact' && {
                justifyContent: 'flex-start'
            }),
            option: Object.assign({}, props.mode === 'compact' && {
                minWidth: undefined,
                maxWidth: undefined,
                width: undefined
            }),
            optionText: Object.assign({}, props.mode === 'compact' && {
                fontSize: 16
            }),
            inputContainer: Object.assign({ padding: 10, height: '100%', overflow: 'hidden', alignItems: 'center' }, props.mode === 'compact' && {
                alignItems: 'flex-start',
            }),
            inputContent: {
                justifyContent: 'flex-start',
                flexDirection: 'row',
                flexWrap: 'wrap',
                alignItems: 'center'
            },
            input: {
                flex: 1,
                marginRight: 25,
                width: '100%'
            },
            error: {
                marginTop: 6,
                marginBottom: 0,
                color: 'rgb(255, 0, 0)'
            },
            signContainer: {},
            sign: {
                color: 'rgb(135, 154, 175)',
                fontSize: 16,
                lineHeight: 18
            },
            applyBtn: {
                minHeight: 52,
                flex: undefined,
                maxWidth: 54,
                width: '100%'
            }
        };
    }
})(({ style, tipOptions, onChange, onSubmit }) => {
    var _a;
    const handleChange = useCallback((option) => {
        var _a;
        const items = ((_a = tipOptions === null || tipOptions === void 0 ? void 0 : tipOptions.choice_items) === null || _a === void 0 ? void 0 : _a.map(item => {
            return item.id == option.id
                ? Object.assign(Object.assign({}, option), { value: 1 }) : Object.assign(Object.assign({}, item), { value: 0 });
        })) || [];
        onChange === null || onChange === void 0 ? void 0 : onChange(items);
    }, [tipOptions === null || tipOptions === void 0 ? void 0 : tipOptions.choice_items]);
    return (_jsx(View, { style: style === null || style === void 0 ? void 0 : style.container, children: _jsx(View, { style: style === null || style === void 0 ? void 0 : style.options, children: (_a = tipOptions === null || tipOptions === void 0 ? void 0 : tipOptions.choice_items) === null || _a === void 0 ? void 0 : _a.map(option => (_jsx(OptionView, { onChange: handleChange, value: option, containerStyle: style === null || style === void 0 ? void 0 : style.option, textStyle: style === null || style === void 0 ? void 0 : style.optionText, onSubmit: onSubmit }, option.id))) }) }));
});
